import {
  AudioLines,
  Disc3,
  Drum,
  Flame,
  Guitar,
  Headphones,
  Heart,
  Mic2,
  Moon,
  Music4,
  PartyPopper,
  Piano,
  Radio,
  Sparkles,
  type LucideIcon,
} from "lucide-react";

/** Name hints first (Persian or Latin), so "راک" gets a guitar and "عاشقانه" a heart. */
const KEYWORDS: [RegExp, LucideIcon][] = [
  [/راک|rock|متال|metal/i, Guitar],
  [/سنتی|کلاسیک|classic|پیانو|piano|بی.?کلام|instrument/i, Piano],
  [/رپ|rap|هیپ|hip/i, Mic2],
  [/عاشقانه|love|romant/i, Heart],
  [/شاد|party|رقص|dance|بندری/i, PartyPopper],
  [/غمگین|sad|آرام|chill|خواب|sleep|lofi/i, Moon],
  [/الکترونیک|electro|edm|تکنو|techno|هاوس|house/i, AudioLines],
  [/محلی|folk|کردی|لری|ترکی|درام|drum|ریتم/i, Drum],
  [/جدید|new|تازه|ترند|trend|داغ/i, Flame],
  [/رادیو|radio|پادکست|podcast/i, Radio],
  [/پاپ|pop/i, Sparkles],
];

const FALLBACK: LucideIcon[] = [Music4, Disc3, Headphones, AudioLines, Mic2, Guitar, Piano];

/** Tile colours for categories that have none set — stable per id, readable with white text. */
const PALETTE = [
  "#E13300",
  "#1E3264",
  "#8D67AB",
  "#E8115B",
  "#148A08",
  "#BC5900",
  "#477D95",
  "#AF2896",
  "#0D73EC",
  "#509BF5",
  "#DC148C",
  "#7358FF",
];

function numericId(id: number | string): number {
  const n = Number(id);
  if (Number.isFinite(n)) return Math.abs(Math.trunc(n));
  let hash = 0;
  for (const ch of String(id)) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return Math.abs(hash);
}

export function categoryIcon(category: { id: number | string; name: string }): LucideIcon {
  for (const [pattern, icon] of KEYWORDS) if (pattern.test(category.name)) return icon;
  return FALLBACK[numericId(category.id) % FALLBACK.length]!;
}

export function categoryColor(category: { id: number | string; color?: string | null }): string {
  return category.color || PALETTE[numericId(category.id) % PALETTE.length]!;
}

/** The colour tile's background: the category colour fading darker, like the category page header. */
export function categoryGradient(color: string): string {
  return `linear-gradient(135deg, ${color} 0%, color-mix(in oklab, ${color} 55%, black) 100%)`;
}
